<div class="casilla-resumen container-fluid">
    <div class="row">
        <div class="col-md-12">
            <div class="card p-3">
                <div class="row d-block d-md-block d-xl-none" style="margin-bottom: 3em;">
                    <button (click)="openBottomSheet()" type="button" id="dDistrito" class="btn btn-combo dis-flex space-b">
                        <p class="casilla-label">
                            Mesa: <br> {{selectedOption}}
                        </p>
                        <span class="fa fa-sort-down ic-down"></span>
                    </button>

                </div>
                <div class="row img-esquina">
                    <div class="col-12 col-lg-10">
                        <!-- <app-breadcrumb
                            subtitle="{{ selectedContienda == 'gubernatura' ? '' : (selectedContienda == 'ayuntamientos' ? 'Detalle del Municipio' : (selectedContienda == 'Juntas' ? 'Detalle por Juntas' : 'Detalle del ' + (selectedContienda == 'diputaciones' ? 'Distrito' : selectedContienda) )) }}"
                            subtitle_detalle="Voto Anticipado"
                            [estado]="_obtenerDatosService?.config?.estado"
                            [distrito]="this.rutas.migas?.distrito"
                            [distrito_param]="rutas.migas?.distrito_clave"
                            [seccion]="'Voto Anticipado'"
                            [fromAntiPrev]="selectedContienda == 'gubernatura'"
                        ></app-breadcrumb>  -->
                        <app-breadcrumb
                            subtitle_detalle="Voto Anticipado"
                            [estado]="_obtenerDatosService?.config?.estado"
                            [distrito]="this.rutas.migas?.distrito"
                            [distrito_param]="rutas.migas?.distrito_clave"
                            [seccion]="'Voto Anticipado'"
                            [fromAntiPrev]="selectedContienda == 'gubernatura'"
                        ></app-breadcrumb> 
                        <!-- <div class="texto font-regular d-block">
                            <p>El total de votos calculado y porcentaje que se muestran, se refieren a los votos asentados en las Actas de Escrutinio y Cómputo del Voto Anticipado en Territorio Nacional hasta el momento.</p>
                            <br class="d-block d-xl-none">
                            <p>Por presentación, los decimales de los porcentajes muestran sólo cuatro digitos. No obstante, al considerar todos los decimales, suman 100%</p>
                        </div> -->
                    </div>
                    <div class="col-12 col-lg-10 mb-4">
                    </div>
                </div>
                    
                <div class="row d-none d-md-none d-xl-block" #detalle_votos>
                    <div class="col ">

                        <h4 class="subtitulo-seccion pleca-izquierda">
                            <strong>Votos en Actas Contabilizadas</strong>
                        </h4>
                        
                    </div>
                </div>
                <!-- <div class="acta-digitalizada container-fluid pb-3">
                    <div class="row d-none d-none d-xl-flex">
                        <div class="col-3 col-xl-2 ">
                            <p class="pb-3">Acta digitalizada:</p>
                            <a *ngIf="(objCasilla?.status?.scanner || objCasilla?.status?.movil || objCasilla?.status?.catd)" target="_blank" [href]="actasRoot + (objCasilla?.status?.scanner ? objCasilla?.status?.scanner : (objCasilla?.status?.movil ? objCasilla?.status?.movil : (objCasilla?.status?.catd ? objCasilla?.status?.catd : '')))">
                                <button class="btn boton-rosa txBlanco custom-wd" [disabled]="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil && !objCasilla?.status?.catd)">
                                    <div style="display: inline-flex;">
                                        <i *ngIf="!objCasilla?.status?.catd" class="far fa-file" aria-hidden="true"></i>
                                        <i *ngIf="!objCasilla?.status?.catd" aria-hidden="true" [ngClass]="{fas: (objCasilla?.status?.scanner || objCasilla?.status?.movil), 'far': (!objCasilla?.status?.scanner && !objCasilla?.status?.movil), 'fa-print' : objCasilla?.status?.scanner, 'fa-mobile-alt': (objCasilla?.status?.movil && !objCasilla?.status?.scanner), 'fa-hourglass': (!objCasilla?.status?.scanner && !objCasilla?.status?.movil)}"></i>
                                        <img *ngIf="objCasilla?.status?.catd" src="./assets/img/generales/movil_catd_white.svg" height="16" style="margin-right: 4px;">
                                        <span *ngIf="objCasilla?.status && objCasilla?.status != 'sin_acta'">&nbsp;Ver</span>
                                        <span *ngIf="objCasilla?.status && objCasilla?.status == 'sin_acta'">&nbsp;Sin Acta</span>
                                    </div>
                                </button>
                            </a>
                            <button *ngIf="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil && !objCasilla?.status?.catd)" class="btn boton-rosa txBlanco custom-wd" [disabled]="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil && !objCasilla?.status?.catd)">
                                <div style="display: inline-flex;">
                                    <i *ngIf="!objCasilla?.status?.catd" class="far fa-file" aria-hidden="true"></i>
                                    <i *ngIf="!objCasilla?.status?.catd" aria-hidden="true" [ngClass]="{fas: (objCasilla?.status?.scanner || objCasilla?.status?.movil), 'far': (!objCasilla?.status?.scanner && !objCasilla?.status?.movil), 'fa-print' : objCasilla?.status?.scanner, 'fa-mobile-alt': (objCasilla?.status?.movil && !objCasilla?.status?.scanner), 'fa-hourglass': (!objCasilla?.status?.scanner && !objCasilla?.status?.movil)}"></i>
                                    <img *ngIf="objCasilla?.status?.catd" src="./assets/img/generales/movil_catd_white.svg" height="16" style="margin-right: 4px;">
                                    <span *ngIf="objCasilla?.status && objCasilla?.status != 'sin_acta'">&nbsp;Ver</span>
                                    <span *ngIf="objCasilla?.status && objCasilla?.status == 'sin_acta'">&nbsp;Sin Acta</span>
                                </div>
                            </button>
                        </div>

                        <div class="col-9 col-xl-6">
                            <p class="font-medium pb-3">
                                &nbsp; Imagen procedente de:
                            </p>
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-3 dis-flex border-rightB padding-r-0">
                                        <div class="grupo gris dis-flex">
                                            <i class="far fa-file" aria-hidden="true" style="margin-right: 4px;"></i>
                                            <i class="fas fa-print" aria-hidden="true"></i>
                                            <p>
                                                Escáner
                                            </p>
                                        </div>
                                    </div>

                                    <div class="col-3 dis-flex border-rightB padding-r-0">
                                        <div class="grupo gris dis-flex">
                                            <i class="far fa-file" aria-hidden="true" style="margin-right: 4px;"></i>
                                            <i class="fas fas fa-mobile-alt" aria-hidden="true"></i>
                                            <p>
                                                Movil
                                            </p>

                                            <div class="vline" style="margin-left: 45px;"></div>
                                        </div>
                                    </div>

                                    <div class="col-4 dis-flex">
                                        <div class="grupo gris dis-flex" placement="top"
                                            max-width="500">
                                            <i style="font-size: 1.4em;" class="far fa-file icon-size"></i>
                                            <i style="font-size: 1.4em;" class="far fa-hourglass icon-size"></i>
                                            <p>
                                                Acta en proceso
                                            </p>
                                        </div>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="row d-block d-md-block d-xl-none">
                        <div class="col-6 col-xl-6 border-right">
                            <p class="pb-3">Ver Acta digitalizada en:</p>
                            <a *ngIf="(objCasilla?.status?.scanner || objCasilla?.status?.movil || objCasilla?.status?.catd)"
                                target="_blank" [href]="actasRoot + (objCasilla?.status?.scanner ? objCasilla?.status?.scanner : (objCasilla?.status?.movil ? objCasilla?.status?.movil : ''))">
                                <button class="btn boton-rosa txBlanco custom-wd" [disabled]="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil)">
                                    <i class="far fa-file" aria-hidden="true"></i>
                                    <i class="fas" aria-hidden="true" [ngClass]="{'fa-print' : objCasilla?.status?.scanner, 'fa-mobile-alt': (objCasilla?.status?.movil && objCasilla?.status?.scanner), 'fa-hourglass': (!objCasilla?.status?.scanner && objCasilla?.status?.movil)}"></i>
                                    Ver
                                </button>
                            </a>
                            <button *ngIf="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil && !objCasilla?.status?.catd)" class="btn boton-rosa txBlanco custom-wd" [disabled]="(!objCasilla?.status?.scanner && !objCasilla?.status?.movil)">
                                <i class="far fa-file" aria-hidden="true"></i>
                                <i class="fas" aria-hidden="true" [ngClass]="{'fa-print' : objCasilla?.status?.scanner, 'fa-mobile-alt': (objCasilla?.status?.movil && objCasilla?.status?.scanner), 'fa-hourglass': (!objCasilla?.status?.scanner && objCasilla?.status?.movil)}"></i>
                                Ver
                            </button>
                        </div>
                    </div>
                </div> -->
                <!--************************ TARJETAS EN ESCRITORIO ***********************-->
                <div class="container-fluid d-none d-md-none d-xl-block">
                    <div class="row dis-flex pb-1">
                        <div class="boton-scroll dis-flex cursorPointer" (click)="scrollLeft()">
                            <i class="fas fa-chevron-left" aria-hidden="true"></i>
                        </div>
                        <div class="col-11">
                            <div #widgetsContent class="row dis-flex justify-s scrollH">
                                <div *ngFor="let tarjeta of fichas; let i=index"
                                    class="col-6 col-sm-4 col-md-3 col-lg-2 px-1">
                                    <div class="card-resumen">
                                        <div class="encabezado dis-flex w-100 py-2">
                                            <div class="dis-flex w-100">
                                                <div class="row w-100 dis-flex">
                                                    <img *ngFor="let img of tarjeta?.imgs" class="img-partido" src="{{_obtenerDatosService.pathPartidos}}{{img}}">
                                                    <!-- <p class="pe p-1" *ngFor="let img of tarjeta?.imgs" [ngStyle]="{
                                                        'background-image': 'url(' + _obtenerDatosService.pathPartidos + img +')',
                                                        'background-size': 'contain',
                                                        'background-repeat': 'no-repeat',
                                                        'background-position': 'center',
                                                        'margin': '20px 2px'
                                                    }">
                                                    </p> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="cuerpo dis-flex bgGrisTenue p-2">
                                            <div class="w-50">
                                                <p>Votos</p>
                                                <p class="votos">
                                                    <strong>{{ tarjeta?.total }}</strong>
                                                </p>
                                            </div>
                                            <!-- <div class="w-50 dis-flex flex-col align-e pr-3 pr-xl-0"> -->
                                                <!-- <p>&nbsp;</p>
                                                <p>{{ tarjeta?.porcentaje}}</p> -->
                                                <!-- <p class="estadistica-label" >&nbsp;</p>
                                                <p class="estadistica-val">&nbsp;</p>
                                            </div> -->
                                            <div class="w-50 dis-flex flex-col align-e pr-3 pr-xl-0">
                                                <p>Porcentaje</p>
                                                <p>{{ tarjeta?.porcentaje ? tarjeta?.porcentaje : (tarjeta?.prc ? tarjeta?.prc : 0) }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="boton-scroll dis-flex cursorPointer" (click)="scrollRight()">
                            <i class="fas fa-chevron-right" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
                <div class="texto font-regular d-block">
                    <p>El total de votos calculado y porcentaje que se muestran, se refieren a los votos asentados en las Actas de Escrutinio y Cómputo del Voto Anticipado en Territorio Nacional hasta el momento.</p>
                    <br class="d-block d-xl-none">
                    <p>Por presentación, los decimales de los porcentajes muestran sólo cuatro digitos. No obstante, al considerar todos los decimales, suman 100%</p>
                </div>
                <!--********************************************************************************************************************-->
                <app-resumen-votacion class="d-none d-xl-block"
                    [extranjero_num]="resumen?.extranjero?.total"
                    [extranjero_prc]="resumen?.extranjero?.prc"
                    [hide_acumulados]="false"
                    [acumulados_num]="resumen?.acumulados?.total"
                    [acumulados_prc]="resumen?.acumulados?.prc"
                    [noregistradas_num]="resumen?.no_registradas?.total"
                    [noregistradas_prc]="resumen?.no_registradas?.prc"
                    [nulos_num]="resumen?.nulos?.total"
                    [nulos_prc]="resumen?.nulos?.prc"
                    [total_num]="resumen?.total?.total"
                    [total_prc]="resumen?.total?.prc"
                    [use_observaciones]="false"
                    [use_nulos_tooltip]="selectedContienda == 'ayuntamientos'"
                    [hide_prc]="false"
                    [hide_legend]="true"
                    [extranjero_short]="true"
                    [use_short_info_acumulados]="true"
                    [other_acumulados]="true"
                ></app-resumen-votacion>


                <div class="row d-none d-md-none d-xl-block">
                    <div class="col-md-12">
                        <div class="card mt-3 p-3">
                            
                            <div class="row">
                                <div class="col">
                                    <h4 class="subtitulo-seccion pleca-izquierda">
                                        <strong>Detalle por Actas de Mesa de Escrutinio y Cómputo del Voto Anticipado​</strong>
                                    </h4>
                                </div>
                            </div>
                            <div class="col-12 px-0 mt-4">
                                <div class="acta-digitalizada container-fluid">
                                    <div class="row">
                                        <div class="col-7 pl-0">
                                            <div class="container-fluid">
                                                <div class="row">
                                                    <div class="col-5 dis-flex border-rightB padding-r-0">
                                                        <p class="font-medium text-left padding-r-0 padding-b-15">
                                                            <!-- Imagen procedente de: -->
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-3 dis-flex border-rightB padding-r-0">
                                                        <div class="grupo gris dis-flex">
                                                            <i class="fas fa-file"></i>
                                                            <i class="fas fa-hourglass"></i>
                                                            <p>Acta en proceso</p>

                                                            <div class="vline"></div>
                                                        </div>
                                                    </div>
                                                    <div class="col-5 dis-flex border-rightB padding-r-0 padding-l-0">
                                                        <div class="grupo dis-flex" tooltip="Acta PREP digitalizada por medio de escáner." placement="top" max-width="500">
                                                            <i class="fas fa-file"></i>
                                                            <p>Acta de Mesa de Escrutinio y Cómputo del Voto Anticipado​</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-2 dis-flex border-rightB padding-r-0 padding-l-0" *ngIf="showEscaner">
                                                        <div class="grupo dis-flex cursor-hand" tooltip="Acta PREP digitalizada por medio de escáner." placement="top" max-width="500">
                                                            <i class="far fa-file"></i>
                                                            <i class="fas fa-print" aria-hidden="true"></i>
                                                            <p>Escáner</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-3 dis-flex" *ngIf="showMovil">
                                                        <div class="grupo dis-flex cursor-hand" tooltip="Acta PREP digitalizada por medio de dispositivo móvil." placement="top" max-width="500">
                                                            <i class="fas fa-file"></i>
                                                            <i class="fas fa-mobile-alt"></i>
                                                            <p>Móvil</p>
                                                        </div>
                                                    </div>
                                                    <div class="col-3 dis-flex" *ngIf="showCATD && showConfCatd">
                                                        <div class="grupo dis-flex cursor-hand" 
                                                            tooltip="Acta PREP digitalizada por medio de dispositivo móvil."
                                                            placement="top" max-width="500">
                                                            <div class="grupo dis-flex">
                                                                <div *ngIf="!themeService.isDarkTheme()" style="width: 33px;height: 20px;background-image: url('./assets/img/generales/logo_movil_catd.png');background-repeat: no-repeat;image-rendering: -webkit-optimize-contrast;background-size:contain;"></div>
                                                                <div *ngIf="themeService.isDarkTheme()" style="width: 33px;height: 20px;background-image: url('./assets/img/generales/logo_movil_catd_rosa.png');background-repeat: no-repeat;image-rendering: -webkit-optimize-contrast;background-size:contain;"></div>
                                                                <p class="leyenda">
                                                                    Móvil CATD
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div> 
                                    <div class="table-responsive tabla-seccion max-500">
                                        <table class="table table-striped contenido table-bordered">
                                            <thead class="titulos">
                                                    <tr>
                                                    <th class="sticky-cell table-header-background">
                                                        <div class="dis-flex">
                                                        <ng-container>
                                                            <ng-container>
                                                            <strong>Mesa de Escrutinio</strong>
                                                            </ng-container>
                                                        </ng-container>
                                                        </div>
                                                    </th>
                                                    <th class="sticky-cell table-header-background">
                                                        <div class="dis-flex">
                                                        <ng-container>
                                                            <ng-container>
                                                            <strong>Acta digitalizada</strong>
                                                            </ng-container>
                                                        </ng-container>
                                                        </div>
                                                    </th>
                                                    <th *ngFor="let itemHeader of casilla_table?.headers; let i = index">
                                                        <div class="dis-flex">
                                                            <ng-container>
                                                                <ng-container *ngIf="itemHeader?.text != ''">
                                                                    <strong>
                                                                        {{itemHeader?.text}}
                                                                    </strong>
                                                                </ng-container>
                                                                <ng-container *ngIf="itemHeader?.info && itemHeader?.info == '1'">
                                                                    &nbsp;
                                                                    <span class="tooltip-outer"
                                                                      tooltip="Se refiere a la suma total de votos que realiza el sistema informático con base en los datos que muestran en cada Acta; podrás consultar la cifra del total de votos mostrado en cada Acta en la base de datos del PREP (numeral 26, fr. XIV del Anexo 13 del Reglamento de Elecciones)."
                                                                      placement="top" show-delay="200">
                                                                      <i class="fas fa-info-circle" aria-hidden="true"></i>
                                                                    </span>
                                                                </ng-container>
                                                                <ng-container *ngFor="let img of itemHeader?.imgs">
                                                                    <img class="img-partido" src="{{_obtenerDatosService.pathPartidos}}{{img}}">
                                                                </ng-container>
                                                            </ng-container>
                                                        </div>
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let itemBody of casilla_table?.rows">
                                                    <td class="sticky-cell">
                                                        <!-- <a class="link-text" [routerLink]="['/gubernatura/votos-anticipados/mesa/'+itemBody.param]">{{itemBody?.text}} 
                                                            </a> -->
                                                        <a class="link-text" *ngIf="itemBody.status != 'proceso'" [routerLink]="['/gubernatura/votos-anticipados/mesa/'+itemBody.param]"> {{itemBody?.text}} </a>
                                                        <a *ngIf="itemBody.status == 'proceso'"> {{itemBody?.text}} </a>
                                                    </td>
                                                    <td class="sticky-cell">
                                                        <a target="_blank" [href]="actasRoot + (itemBody.status.catd ? itemBody.status.catd : (itemBody.status.movil? itemBody.status.movil : itemBody.status.scanner))"
                                                        *ngIf="itemBody.status != 'proceso'">
                                                            <ng-container *ngIf="itemBody.status.movil">
                                                                <i class="far fa-file" aria-hidden="true"></i>
                                                                <!-- <i class="fas fas fa-mobile-alt" aria-hidden="true"></i> -->
                                                            </ng-container>
                                                            <ng-container *ngIf="itemBody.status.scanner">
                                                                <i class="far fa-file" aria-hidden="true"></i>
                                                                <!-- <i class="fas fa-print" aria-hidden="true"></i> -->
                                                            </ng-container>
                                                            <ng-container *ngIf="itemBody.status.catd">
                                                                <img *ngIf="!themeService.isDarkTheme()" height="15" [src]="'./assets/img/generales/logo_movil_catd.png'">
                                                                <img *ngIf="themeService.isDarkTheme()" height="15" [src]="'./assets/img/generales/logo_movil_catd_rosa.png'">
                                                            </ng-container>
                                                            <ng-container *ngIf="itemBody.actaDigitalizada === '-'">
                                                                <i class="far fa-file"></i>
                                                                <i class="far fa-hourglass"></i>
                                                            </ng-container>
                                                        </a>
                                                        <a target="_blank" *ngIf="itemBody.status == 'proceso' || itemBody.status == 'sin_acta'">
                                                            <div class="txGris">
                                                                <i class="far fa-file txGris"></i>
                                                                <i class="far fa-hourglass txGris"></i>
                                                            </div>
                                                        </a>
                                                    </td>
                                                    <td *ngFor="let itemVoto of itemBody.columns; let i=index;">
            <!--                                            {{itemVoto}}-->
                                                        <span *ngIf="i < itemBody.columns.length-1; else observacion">{{itemVoto}}</span>
                                                        <ng-template #observacion>
                                                            <span class="link-observaciones" [ngClass]="{noUnderline: (itemVoto == '-')}">{{itemVoto}}</span>
                                                        </ng-template>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
    
    <!--********************* TABLA MOVIL *********************-->
    <div class="row d-block d-md-block d-xl-none">
        <div class="col-12">
            <h4 class="subtitulo-seccion pleca-izquierda">
                <strong>Votos en Acta Contabilizada</strong>
            </h4>
        </div>
        <div class="row mb-5" *ngIf="selectedOptionIndx == -1">
            <div class="w-100 dis-flex table-movil py-2 pl-4" *ngFor="let item of fichas; let indx = index;" >
                <table class="w-100 " [ngClass]="{'table-mov-striped': indx%2 == 0, 'table-mov': indx%2 != 0}">
                    <tr>
                        <td class="w-col">
                            <img class="logo" height="30px" *ngIf="item.imgs?.length > 0" 
                                src="{{_obtenerDatosService.pathPartidos}}{{item.imgs[0]}}"/>
                        </td>
                        <td class="w-col">
                            <p class="label-votos">Votos</p>
                            <p class="votos"><strong>{{ item?.total }}</strong></p>
                        </td>
                        <td class="w-col">
                            <!-- <p class="label-votos align-center"><br>&nbsp;</p> -->
                            <p class="label-votos">Porcentaje</p>
                            <p class="votos"><strong>{{ item?.prc }}</strong></p>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="row mb-5" *ngIf="selectedOptionIndx > -1">
            <div class="w-100">
                <div class="w-100 dis-flex table-movil py-2 pl-4" *ngFor="let item of casillasInfo[casilla_table?.rows[selectedOptionIndx]?.param]?.fichas; let indx = index" >
                    <table class="w-100">
                        <tr>
                            <td class="w-col">
                                <img class="logo" height="30px" *ngIf="item.imgs?.length > 0"
                                    src="{{_obtenerDatosService.pathPartidos}}{{item.imgs[0]}}"/>
                            </td>
                            <td class="w-col">
                                <p class="votos">Votos</p>
                                <p class="label-votos"><strong>{{ item?.total }}</strong></p>
                            </td>
                            <td class="w-col">
                                <!-- <p class="label-votos align-center"><br>&nbsp;</p> -->
                                <p class="votos">Porcentaje</p>
                                <p class="label-votos"><strong>{{ item?.prc }}</strong></p>
                            </td>
                            <!-- <td class="w-col">
                                <p class="label-votos align-center"><br><strong>{{ item?.prc }}</strong></p>
                            </td> -->
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
    <app-resumen-votacion class="d-block d-xl-none"
        [acumulados_num]="resumen?.acumulados?.total"
        [acumulados_prc]="resumen?.acumulados?.prc"
        [extranjero_num]="resumen?.acumulados?.total"
        [extranjero_prc]="resumen?.extranjero?.prc"
        [hide_acumulados]="true"
        [noregistradas_num]="resumen?.no_registradas?.total"
        [noregistradas_prc]="resumen?.no_registradas?.prc"
        [nulos_num]="resumen?.nulos?.total"
        [nulos_prc]="resumen?.nulos?.prc"
        [total_num]="resumen?.total?.total"
        [total_prc]="resumen?.total?.prc"
        [hide_prc]="true"
        [extranjero]="true"
        [use_acumulados]="true"
        [use_short_info_acumulados]="true"
    ></app-resumen-votacion>
    <!--*****************************************************************-->
    <div class="d-block d-xl-none">
        <app-resumen-votacion-mobile
            [total_num]="resumen?.total?.total"
            [total_prc]="resumen?.total?.prc"
            [hide_prc]="true">
        </app-resumen-votacion-mobile>
    </div>
    <!--    <div class="card p-3">-->
    <div class="row">
        <div class="col-md-12">
            <div class="estadistica-casilla-movil card mt-3 p-3">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col">
                            <h4 class="subtitulo-seccion pleca-izquierda">
                                <strong>Estadística por Actas de Mesa de Escrutinio y Cómputo del Voto Anticipado​</strong>
                            </h4>
                        </div>
                    </div>
                </div>
                <div class="container-fluid d-none d-xl-block pt-3">
                    <div class="row">
                        <div class="col">
                            <p class="subtitulo underline">
                                <strong>Participación Ciudadana con base en la Lista Nominal de las Mesas de Escrutinio y Cómputo del Voto Anticipado​</strong>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="container-fluid d-none d-xl-block">
                    <div class="row my-2">
                        <div class="col-12">
                            <table class="table table-striped contenido table-bordered" style="border-color: transparent !important;">
                                <thead class="titulos">
                                    <tr>
                                        <th class="sticky-cell table-header-est-background">
                                            <div class="dis-flex">
                                            <ng-container>
                                                <ng-container>
                                                <strong>Mesa de Escrutinio</strong>
                                                </ng-container>
                                            </ng-container>
                                            </div>
                                        </th>
                                        <th class="sticky-cell table-header-est-background">
                                            <div class="dis-flex">
                                            <ng-container>
                                                <ng-container>
                                                <strong>Total de Votos</strong>
                                                &nbsp;
                                                <span class="tooltip-outer"
                                                  tooltip="Se refiere a la suma total de votos que realiza el sistema informático con base en los datos que muestran en cada Acta; podrás consultar la cifra del total de votos mostrado en cada Acta en la base de datos del PREP (numeral 26, fr. XIV del Anexo 13 del Reglamento de Elecciones)."
                                                  placement="top" show-delay="200">
                                                  <i class="fas fa-info-circle" aria-hidden="true"></i>
                                                </span>
                                                </ng-container>
                                            </ng-container>
                                            </div>
                                        </th>
                                        <th class="sticky-cell table-header-est-background">
                                            <div class="dis-flex">
                                            <ng-container>
                                                <ng-container>
                                                <strong>Lista Nominal</strong>
                                                </ng-container>
                                            </ng-container>
                                            </div>
                                        </th>
                                        <th class="sticky-cell table-header-est-background">
                                            <div class="dis-flex">
                                            <ng-container>
                                                <ng-container>
                                                <strong>Participación ciudadana</strong>
                                                </ng-container>
                                            </ng-container>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let itemBody of estadistica_anticipados">
                                        <td class="estadistica-cell" style="border: none;">
                                            <span>{{itemBody.casilla}}</span>
                                        </td>
                                        <td class="estadistica-cell" style="border: none;">
                                            <span>{{itemBody.total}}</span>
                                        </td>
                                        <td class="estadistica-cell" style="border: none;">
                                            <span>{{itemBody.lista_nominal}}</span>
                                        </td>
                                        <td class="estadistica-cell" style="border: none;">
                                            <span>{{itemBody.prc}}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <movil-estadistica-content
                [tipoEstadistica]="6"
                [nombreCasilla]="'de Casillas'"
                [infoParticipacion]="estadistica_anticipados"
                
                
            ></movil-estadistica-content>
        </div>
    </div>
    <div class="row" #observaciones>
        <div class="col-md-12">
            <div class="estadistica-casilla observacionesActa card mt-3 p-3">
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-lg-10 col-md-8">
                            <h4 class="subtitulo-seccion pleca-izquierda">
                                <strong>Observaciones en Acta</strong>
                            </h4>
                        </div>
                        <div class="col-lg-2 col-md-4" style="text-align: end;">
                            <span class="subtitulo-link" (click)="goToAnchor(detalle_votos)">Regresar al detalle de votos</span>
                        </div>
                    </div>
                </div>
                <div class="container-fluid py-4">
                    <div class="row justify-content-center">
                        <div class="col-11">
                            <div class="container-fluid">
                                <div class="row">
                                    <div class="col-12 col-md-6">
                                        <h4 class="subtitulo-seccion pleca-izquierda pleca-aqua">
                                            <strong class="txAqua">Contabilizadas</strong>
                                        </h4>
                                        <div class="grupo py-3">
                                            <p>
                                                Algunas Actas pueden presentar inconsistencias, pero tienen información que permite contabilizarlas:
                                            </p>
                                        </div>
                                        <div class="grupo py-3">
                                            <p class="pb-2">
                                                <strong>
                                                    Ilegible
                                                </strong>
                                            </p>
                                            <p>
                                                La cantidad de votos en algún campo del Acta PREP no puede leerse, tanto
                                                en letra como en número.
                                            </p>
                                        </div>
                                        <div class="grupo py-3">
                                            <p class="pb-2">
                                                <strong>
                                                    Sin Dato
                                                </strong>
                                            </p>
                                            <p>
                                                La cantidad de votos no fue asentada en el Acta PREP ni en letra ni en
                                                número en algún campo del Acta PREP.
                                            </p>
                                        </div>
                                        <!-- <div class="grupo py-3 mb-2">
                                            <p class="pb-2">
                                                <strong>
                                                    Identificación por Proceso Técnico Operativo
                                                </strong>
                                            </p>
                                            <p>
                                                Los datos del Acta PREP no se identificaron y sé solicitó verificarlos
                                                por algún procedimiento válido establecido en el Proceso Técnico
                                                Operativo.
                                            </p>
                                        </div> -->
                                        <!-- <div class="d-none d-xl-block">
                                            <h4 class="subtitulo-seccion pleca-izquierda pleca-morada mt-5">
                                                <strong><span class="txMorado">No identificadas -</span> Fuera del
                                                    catálogo</strong>
                                            </h4>
                                            <div class="grupo py-3">
                                                <p>
                                                    No es posible ubicar el Acta PREP dentro de la lista de Actas de
                                                    casillas aprobadas por el INE, al presentar alguna omisión, ilegibilidad
                                                    o error en sus datos de identificación. Para fines de publicación, el
                                                    Acta se muestra al final del listado de Actas
                                                    aprobadas en la Base de Datos.
                                                </p>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="col-12 col-md-6">
                                        <h4 class="subtitulo-seccion pleca-izquierda pleca-morada">
                                            <strong class="label-no-contabilizada">No Contabilizadas</strong>
                                        </h4>
                                        <div class="grupo py-3">
                                            <p class="pb-2">
                                                <strong>
                                                    Excede Lista Nominal
                                                </strong>
                                            </p>
                                            <p>
                                                La suma de todos los votos en el Acta PREP, excede el número de
                                                ciudadanas y ciudadanos en la Lista Nominal de electores de la casilla,
                                                incluido el número de votos emitidos por las representaciones de los
                                                Partido Políticos.
                                            </p>
                                        </div>
                                        <div class="grupo py-3">
                                            <p class="pb-2">
                                                <strong>
                                                    Sin Acta
                                                </strong>
                                            </p>
                                            <p class="pb-2">
                                                El Acta PREP no llegó junto con el paquete electoral al Centro de Acopio
                                                y Transmisión de Datos (CATD), por algunas de las siguientes causas:
                                            </p>
                                            <p>
                                                1. Sin Acta por casilla no instalada.
                                            </p>
                                            <p>
                                                2. Sin Acta por paquete no entregado.
                                            </p>
                                            <p>
                                                3. Sin Acta por paquete entregado sin bolsa.
                                            </p>
                                        </div>
                                        <div class="grupo py-3">
                                            <p class="pb-2">
                                                <strong>
                                                    Todos los campos ilegibles o sin dato
                                                </strong>
                                            </p>
                                            <p>
                                                Todos los campos del Acta PREP correspondientes al número de votos, son
                                                ilegibles o no contienen dato alguno, tanto en letra como en número.
                                            </p>
                                        </div>
                                        <!-- <div class="grupo py-3">
                                            <p class="pb-2">
                                                <strong>
                                                    Todos los campos vacíos
                                                </strong>
                                            </p>
                                            <p>
                                                Todos los campos del Acta PREP correspondientes al número de votos, se
                                                encuentran vacíos tanto en letra como en número.
                                            </p>
                                        </div> -->
                                        <div class="d-block d-sm-none">
                                            <h4 class="subtitulo-seccion pleca-izquierda pleca-morada mt-5">
                                                <strong><span class="txMorado">No identificadas -</span> Fuera del catálogo</strong>
                                            </h4>
                                            <div class="grupo py-3">
                                                <p>
                                                    No es posible ubicar el Acta PREP dentro de la lista de Actas de casillas aprobadas por el INE, al presentar alguna omisión, ilegibilidad o error en sus datos de identificación. Para fines de publicación, el Acta se muestra al final del listado de Actas aprobadas en la  Base de Datos.
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!--    </div>-->
</div>